export const DISLOYALTY_PROMOTIONAL_RATE = 'DISLOYALTY_PROMO';

export const DISLOYALTY_PROMOTIONAL_TARGET_RATES = {
  flexibleRate: 'RA1',
} as const;
